import { useEffect } from 'react'
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { GetRoleListAction } from '../Redux/Actions/RoleAction';
//import { IReduxState } from '../utils/types';
import GetAllowedRoutes from './allowedRoutes';
import { AuthRoutes, Routes } from './allRoutes';

const AppRoutes: FC = () => {
  //const [accessScreen, setAccessScreen] = useState<any>([])
  // const roleState = useSelector((state: IReduxState) => state.Roles)
  //const AuthState = useSelector((state: IReduxState) => state.Auth);
  // const roles = AuthState?.role
  const dispatch = useDispatch()
  //const allowedRoutes = GetAllowedRoutes(Routes);
  // console.log('roleState', roleState.roles);

  useEffect(() => {
    if(localStorage.getItem('token')){ 
      dispatch(GetRoleListAction())
    }
  }, [dispatch])

  // useEffect(() => {
  //   const getAccess = roles.map((roleName) => {
  //     return roleState.roles.filter((item: any) => item.role_name === roleName)[0]
  //   })

  //   const temp: any = [];
  //   getAccess && getAccess.map((access: any) => {
  //     access?.access_screen.map((screen: any) => {
  //       if (!temp.includes(screen)) {
  //         temp.push(screen)
  //       }
  //     })
  //   })

  //   const tempAccessScreen: any = []
  //   temp.map((screen: any) => {
  //     const xy = Routes.filter((route: any) => route?.title === screen)[0]
  //     if (xy) tempAccessScreen.push(xy)
  //   })
  // console.log('access', accessScreen);

  // }, [roleState.roles])

  // useEffect(() => {
  //   // if (allowedRoutes?.length !== 0) {
  //   //   console.log('access', accessScreen);
  //   //   setAccessScreen(allowedRoutes)
  //   // }
  //   updateAccess()
  // }, [accessScreen])

  // const updateAccess = useCallback(() => {
  //   if (allowedRoutes?.length !== 0) {
  //     console.log('access', allowedRoutes);
  //     setAccessScreen(allowedRoutes)
  //   }
  // }, [accessScreen])

  const routes = useRoutes(GetAllowedRoutes([...Routes, ...AuthRoutes]));
  // const routes = useRoutes([...accessScreen, ...AuthRoutes]);
  return routes;
};

export default AppRoutes;